


































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroGameHistorySummaryDocument } from "../../services/datatypes";
import { WhoWinsGame } from "../../services/who-wins-game";
import { JinroPlayStatus } from "../../services/jinro-play-status";

@Component
export default class ListGameHistories extends Vue {
  @Prop() readonly gameHistorySummaries!: Array<
    JinroGameHistorySummaryDocument
  >;
  @Prop() readonly isRoomSpecified!: boolean;
  detacher?: firebase.Unsubscribe;

  defaultTxt(dayN: number, playStatus: JinroPlayStatus): string {
    let plsts = "";
    if (playStatus === JinroPlayStatus.Execution) {
      plsts = "処刑";
    }
    if (playStatus === JinroPlayStatus.Night) {
      plsts = "夜";
    }
    return `${dayN}日目  ${plsts} `;
  }

  gameResult(whoWinsGame: WhoWinsGame): string {
    if (whoWinsGame === WhoWinsGame.JinroTeam) {
      return "人狼陣営の勝利";
    }
    if (whoWinsGame === WhoWinsGame.MurabitoTeam) {
      return "村人陣営の勝利";
    }

    return "-";
  }

  compare(a: any, b: any) {
    let r = 0;
    if (a.timeEnded > b.timeEnded) {
      r = -1;
    } else if (a.timeEnded < b.timeEnded) {
      r = 1;
    }

    return r;
  }

  get summaries(): Array<any> {
    if (!this.gameHistorySummaries) {
      return [];
    }
    const gameHistorySummaries = this.gameHistorySummaries as Array<
      JinroGameHistorySummaryDocument
    >;
    const params = gameHistorySummaries.map(gameHistorySummary => {
      return {
        owner: gameHistorySummary.owner,
        jinroRoomId: gameHistorySummary.jinroRoom.id,
        jinroRoomTitle: gameHistorySummary.jinroRoom.title,
        jinroGameId: gameHistorySummary.jinroGame.id,
        jinroPlayerCount: gameHistorySummary.playersWithRole.length,
        whoWinsGame: gameHistorySummary.whoWinsGame,
        dayN: gameHistorySummary.dayN,
        playStatus: gameHistorySummary.playStatus,
        timeEnded: gameHistorySummary.timeEnded
      };
    });
    params.sort(this.compare);

    return params;
  }

  isOwnerMe(gameOwner: string): string {
    if (!this.$store.state.firebaseUser) {
      return "";
    }
    return this.$store.state.firebaseUser.uid === gameOwner ? "自分" : "他人";
  }
}
